import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-white px-6 py-24">
      <SEO
        title="404 - Siden blev ikke fundet - Advokatfirmaet Kopp"
        description="Den efterspurgte side kunne ikke findes hos Advokatfirmaet Kopp ApS."
      />

      <div className="max-w-lg text-center space-y-6">
        <span className="text-6xl font-bold text-[#1c3848] block">404</span>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
          Siden blev ikke fundet
        </h1>
        <p className="text-sm text-slate-600 leading-relaxed">
          Beklager, den side du leder efter findes desværre ikke, eller er blevet flyttet.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 max-w-xs sm:max-w-none mx-auto">
          <Link
            to="/"
            className="text-center px-8 py-3.5 bg-[#1c3848] hover:bg-[#142935] text-white text-xs font-semibold uppercase tracking-widest rounded-none transition-colors w-full sm:w-auto"
          >
            Tilbage til forsiden
          </Link>
          <Link
            to="/fagomraader/"
            className="text-center px-8 py-3.5 border border-[#1c3848] text-[#1c3848] hover:bg-slate-50 text-xs font-semibold uppercase tracking-widest rounded-none transition-colors w-full sm:w-auto"
          >
            Se fagområder
          </Link>
        </div>
      </div>
    </div>
  );
}
